import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FileInlineComponent } from '@bazis/shared/components/file/file-inline.component';
import { AvatarModule } from '@bazis/shared/components/web/avatar/avatar.module';
import { IconModule } from '@bazis/shared/components/web/icon/icon.module';
import { TooltipModule } from '@bazis/shared/components/web/tooltip/tooltip.module';
import { FileSizePipe } from '@bazis/shared/pipes/file-size.pipe';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    selector: 'app-file-inline',
    templateUrl: './file-inline.component.html',
    imports: [IconModule, TooltipModule, FileSizePipe, TranslocoModule, CommonModule, AvatarModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppFileInlineComponent extends FileInlineComponent {}
